webpackJsonp([1],{

/***/ 15:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "db", function() { return db; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuefire__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_app__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase_firestore__ = __webpack_require__(324);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuefire__["a" /* default */]);

// initialize your firebase app
__WEBPACK_IMPORTED_MODULE_6_firebase_app___default.a.initializeApp({
  apiKey: "AIzaSyAOMLOQpx52bK861g5w2mTEWZrb6oooHS8",
  authDomain: "bletracker-98d99.firebaseapp.com",
  projectId: 'bletracker-98d99',
  databaseURL: 'https://bletracker-98d99.firebaseio.com',
  storageBucket: "bletracker-98d99.appspot.com",
  messagingSenderId: "202883067965"
});

// save a reference to the firestore database
// to access it in the future

var db = __WEBPACK_IMPORTED_MODULE_6_firebase_app___default.a.firestore();
// const settings = {/* your settings... */ timestampsInSnapshots: true};
// db.settings(settings);

// Enable offline persistance
// db.enablePersistence();

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin({
  data: function data() {
    return {
      get globalVersionNumber() {
        return "1.0.4";
      }
    };
  }
});

var app = void 0;
__WEBPACK_IMPORTED_MODULE_6_firebase_app___default.a.auth().onAuthStateChanged(function (user) {
  if (!app) {
    app = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
      el: '#app',
      router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
      components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
      template: '<App/>'
    });
  }
});

/***/ }),

/***/ 189:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// const users = db.collection('users')
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dataReady: false,
      search: '',
      users: [],
      userStatus: [],
      headers: [{
        text: 'Card ID', align: 'left', value: 'kontaktId'
      }, { text: 'Name', align: 'right', value: 'name' }, {
        text: 'Beacon Add.',
        align: 'right',
        sortable: true,
        value: 'beaconAddress'
      }, { text: 'Action', align: 'right' }],
      dialog: false,
      dialogText: {
        title: 'Add User',
        button: 'Save'
      },
      user: {
        firstName: '',
        lastName: '',
        beaconAddress: '',
        kontaktId: '',
        id: '',
        hideOnMainScreen: false
      },
      hideOnMainScreen: false,
      deleteUserModal: false,
      // Admin only
      currentUserAdmin: false
    };
  },
  created: function created() {
    var _this = this;

    if (__WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser) {
      this.name = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser.email;
      var uid = __WEBPACK_IMPORTED_MODULE_1_firebase___default.a.auth().currentUser.uid;
      var query = __WEBPACK_IMPORTED_MODULE_0__main_js__["db"].collection('adminUsers').where('uid', '==', uid).get().then(function (snapshot) {
        if (snapshot.docs.length === 1) {
          _this.currentUserAdmin = true;
        }
      });
    }
  },

  computed: {
    dataTable: function dataTable() {
      var data = [];
      if (this.users !== null) {
        this.users.forEach(function (u) {
          var obj = {
            name: u.firstName + ' ' + u.lastName,
            beaconAddress: u.beaconAddress,
            kontaktId: u.kontaktId,
            id: u.id,
            hideOnMainScreen: u.hideOnMainScreen == null ? false : u.hideOnMainScreen
          };
          data.push(obj);
        });
      }
      return data;
    },
    headersComputed: function headersComputed() {
      var headers = [{
        text: 'Card ID', align: 'left', value: 'kontaktId'
      }, { text: 'Name', align: 'right', value: 'name' }, { text: 'Action', align: 'right' }];
      // v-show="currentUserAdmin"
      if (this.currentUserAdmin) {
        headers = [{
          text: 'Card ID', align: 'left', value: 'kontaktId'
        }, { text: 'Name', align: 'right', value: 'name' }, {
          text: 'Beacon Add.',
          align: 'right',
          sortable: true,
          value: 'beaconAddress'
        }, { text: 'Action', align: 'right' }];
      }
      return headers;
    }
  },
  methods: {
    openEditDialog: function openEditDialog(userId) {
      this.dialogText.title = 'Edit User';
      this.dialogText.button = 'Update';
      this.user = this.users.find(function (u) {
        return u.id === userId;
      });
      this.dialog = true;
    },
    saveUser: function saveUser() {
      console.log(this.user);
      var obj = {
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        beaconAddress: this.user.beaconAddress,
        kontaktId: this.user.kontaktId,
        hideOnMainScreen: 'hideOnMainScreen' in this.user ? this.user.hideOnMainScreen : false
      };
      console.log(obj);
      if (this.user.id === '') {
        __WEBPACK_IMPORTED_MODULE_0__main_js__["db"].collection('users').add(obj);
      } else {
        __WEBPACK_IMPORTED_MODULE_0__main_js__["db"].collection('users').doc(this.user.id).update(obj);
      }
      this.dialog = false;
      this.user = {
        firstName: '',
        lastName: '',
        beaconAddress: '',
        id: '',
        hideOnMainScreen: false
      };
    },
    deleteUser: function deleteUser(user) {
      console.log(user);
      this.user = user;
      this.deleteUserModal = true;
    },
    deleteUserFromFirebase: function deleteUserFromFirebase() {
      __WEBPACK_IMPORTED_MODULE_0__main_js__["db"].collection('users').doc(this.user.id).delete();
      this.deleteUserModal = false;
      this.user = {
        firstName: '',
        lastName: '',
        beaconAddress: '',
        id: '',
        hideOnMainScreen: false
      };
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$bind('users', __WEBPACK_IMPORTED_MODULE_0__main_js__["db"].collection('users')).then(function (doc) {
      _this2.dataReady = true;
    }).catch(function (error) {
      console.log('error in loading: ', error);
    });
  }
});

/***/ }),

/***/ 190:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dataReady: false,
      search: '',
      userLog: [],
      pagination: { 'sortBy': 'time', 'descending': true, 'rowsPerPage': 25 },
      headers: [{
        text: 'Name',
        align: 'left',
        sortable: true,
        value: 'name'
      }, { text: 'Updated', align: 'right', value: 'time', sortable: true }, { text: 'Status', align: 'right', value: 'status' }],
      // Date picker
      date: new Date().toISOString().substr(0, 10),
      menu: false
    };
  },

  methods: {
    chipColor: function chipColor(status) {
      var color = 'grey';
      switch (status) {
        case 'Offsite':
          color = 'green';
          break;
        case 'Onsite G2':
          color = 'yellow';
          break;
        case 'Onsite G3':
          color = 'blue';
          break;
      }
      return color;
    }
  },
  computed: {
    dateYear: function dateYear() {
      return this.date.getYear();
    },
    dataTable: function dataTable() {
      var data = [];
      if (this.userLog !== null) {
        this.userLog.forEach(function (u) {
          var obj = {
            name: u.firstName + ' ' + u.lastName,
            time: u.updatedAt.toDate(),
            status: u.status
          };
          data.push(obj);
        });
      }
      return data;
    }
  },
  firestore: function firestore() {
    return {
      userLog: __WEBPACK_IMPORTED_MODULE_1__main_js__["db"].collection('userLogs').orderBy('updatedAt').where('updatedAt', '>', new Date(this.date))
    };
  },

  watch: {
    // whenever date changes, this function will run
    date: function date(newDate) {
      var _this = this;

      console.log('does this fire');
      var today = new Date(newDate);
      var tomorrow = new Date(today);
      tomorrow.setDate(today.getDate() + 1);
      today.setHours(0, 0, 0, 0);
      tomorrow.setHours(0, 0, 0, 0);
      this.dateReady = false;
      this.$bind('userLog', __WEBPACK_IMPORTED_MODULE_1__main_js__["db"].collection('userLogs').where('updatedAt', '>=', today).where('updatedAt', '<=', tomorrow)).then(function (doc) {
        _this.dataReady = true;
      }).catch(function (error) {
        console.log('error in loading: ', error);
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    console.log('Loaded into');
    var today = new Date();
    var tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);
    today.setHours(0, 0, 0, 0);
    tomorrow.setHours(0, 0, 0, 0);
    console.log(tomorrow, today.getDate());
    this.$bind('userLog', __WEBPACK_IMPORTED_MODULE_1__main_js__["db"].collection('userLogs').where('updatedAt', '>=', today).where('updatedAt', '<=', tomorrow)).then(function (doc) {
      console.log('data ready');
      _this2.dataReady = true;
    }).catch(function (error) {
      console.log('error in loading: ', error);
    });
  },

  filters: {
    moment: function moment(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('MMM Do YYYY h:mm:ss a');
    }
  }
});

/***/ }),

/***/ 191:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      contacts: [{ name: 'Jarrod Lodge', email: 'jarrod@limedigital.nz', phone: '+64211352853' }, { name: 'Paul Plester', email: 'paul.plester@rfdsl.co.nz', phone: '+64278633513' }]
    };
  }
});

/***/ }),

/***/ 192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 193:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PersonCard__ = __webpack_require__(316);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PersonCard: __WEBPACK_IMPORTED_MODULE_4__components_PersonCard__["a" /* default */]
  },
  data: function data() {
    return {
      name: '',
      dataReady: false,
      reportDataReady: false,
      newEventCreated: false,
      emergencyTriggered: false,
      emergencyActive: false,
      emergencyText: 'Start emergency',
      filterDialog: false,
      filter: {
        noActivity: true,
        visuallySeen: false
      },
      search: '',
      closeEmergencyDialog: false,
      // Firebase
      emergencyReports: [],
      users: [],
      userVisuallySeenKey: [],
      bottomNav: 'recent'
    };
  },

  methods: {
    chipColor: function chipColor(status) {
      var color = 'grey';
      switch (status) {
        case 'Offsite':
          color = 'green';
          break;
        case 'Onsite G2':
          color = 'yellow';
          break;
        case 'Onsite G3':
          color = 'blue';
          break;
      }
      return color;
    },
    chooseDateFilter: function chooseDateFilter(status) {
      if (status === 'No activity') {
        return this.moment;
      } else {
        return this.momentDay;
      }
    },
    myLoop: function (_myLoop) {
      function myLoop() {
        return _myLoop.apply(this, arguments);
      }

      myLoop.toString = function () {
        return _myLoop.toString();
      };

      return myLoop;
    }(function () {
      var i = this.i;
      setTimeout(function () {

        console.log(i);
        i--;
        if (i > 0) {
          myLoop();
        }
      }, 1000);
    }),
    startEmergency: function startEmergency() {
      if (this.emergencyTriggered) {
        // this.emergencyActive = true
        this.initFirebaseReport();
      }
      this.emergencyText = 'Are you sure?, Yes';
      this.emergencyTriggered = true;
    },
    cancelEmergency: function cancelEmergency() {
      this.emergencyTriggered = false;
    },
    updateSeenStatus: function updateSeenStatus(person, key) {
      var obj = {
        key: key,
        person: person,
        timeSeen: new Date()
      };
      var tempReport = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.emergencyReports[0]);
      var index = tempReport.userVisuallySeenKey.findIndex(function (x) {
        return x.person.name === person.name;
      });
      if (index == -1) {
        tempReport.userVisuallySeenKey.push(obj);
      } else {
        tempReport.userVisuallySeenKey.splice(index, 1);
      }
      var ref = __WEBPACK_IMPORTED_MODULE_3__main_js__["db"].collection('emergencyReports').doc(this.emergencyReports[0].id);
      ref.set(tempReport);
    },
    hasUserBeenChecked: function hasUserBeenChecked(person) {
      var check = false;
      if (this.emergencyActive) {

        for (var i = 0; i < this.emergencyReports[0].userVisuallySeenKey.length; i++) {
          if (this.emergencyReports[0].userVisuallySeenKey[i].person.name === person.name) {
            check = true;
          }
        }
      }
      return check;
    },
    closeEmergency: function closeEmergency() {
      var _this = this;

      // Open a dialog to confirm
      var report = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.emergencyReports[0], {
        end: {
          closedBy: this.name,
          endTime: new Date(),
          totalStaffActiveToday: this.totalStaffActiveToday,
          totalStaffStillOnsite: this.totalStaffStillOnsite,
          totalStaffSeen: this.totalStaffSeen
        }
      });
      report.emergencyActive = false;
      var ref = __WEBPACK_IMPORTED_MODULE_3__main_js__["db"].collection('emergencyReports').doc(this.emergencyReports[0].id);
      ref.set(report).then(function (res) {
        _this.emergencyTriggered = false;
        _this.emergencyActive = false;
        _this.emergencyText = 'Start emergency';
        _this.closeEmergencyDialog = false;
      });
    },

    // Firebase
    initFirebaseReport: function initFirebaseReport() {
      var report = {
        start: {
          initiatedBy: this.name,
          currnetStatusOfStaffAtStart: this.users,
          totalStaffActiveToday: this.totalStaffActiveToday,
          totalStaffStillOnsite: this.totalStaffStillOnsite
        },
        userVisuallySeenKey: [],
        emergencyActive: true,
        startTime: new Date()
      };
      var reportID = report.startTime.getFullYear() + '-' + report.startTime.getMonth() + '-' + report.startTime.getDate();
      var ref = __WEBPACK_IMPORTED_MODULE_3__main_js__["db"].collection('emergencyReports').doc(reportID);
      ref.set(report);
    }
  },
  computed: {
    dataTable: function dataTable() {
      var _this2 = this;

      var data = [];
      if (this.users !== null) {
        this.users.forEach(function (u) {
          if ('status' in u && u.firstName !== '') {

            var now = new Date();
            var obj = {
              name: u.firstName + ' ' + u.lastName,
              time: u.updatedAt.toDate(),
              status: 'No activity'
            };
            if (u.updatedAt.toDate().getDate() === now.getDate()) {
              obj.status = u.status;
            }
            if (_this2.filter.noActivity || _this2.filter.visuallySeen) {
              if (obj.status !== 'No activity' && !_this2.filter.visuallySeen && _this2.filter.noActivity) {
                data.push(obj);
              }
              if (!_this2.hasUserBeenChecked(obj) && _this2.filter.visuallySeen) {
                var index = data.findIndex(function (x) {
                  return x.name === obj.name;
                });
                if (index === -1) {
                  if (obj.status !== 'No activity' && _this2.filter.noActivity) {
                    data.push(obj);
                  } else if (!_this2.filter.noActivity) {
                    data.push(obj);
                  }
                }
              }
            } else {
              data.push(obj);
            }
          }
        });
      }
      return data;
    },
    totalStaffActiveToday: function totalStaffActiveToday() {
      var count = [];
      var now = new Date();
      if (this.dataReady) {
        count = this.dataTable.filter(function (u) {
          return u.time.getDate() === now.getDate();
        });
      }
      return count.length;
    },
    totalStaffStillOnsite: function totalStaffStillOnsite() {
      var now = new Date();
      if (!this.dataReady) {
        return 0;
      }
      return this.dataTable.filter(function (d) {
        if ((d.status === 'Onsite, via Gate 3' || d.status === 'Onsite, via Gate 2') && d.time.getDate() === now.getDate()) {
          return true;
        }
      }).length;
    },
    totalStaffSeen: function totalStaffSeen() {
      return this.emergencyReports[0].userVisuallySeenKey.length;
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$bind('users', __WEBPACK_IMPORTED_MODULE_3__main_js__["db"].collection('users').orderBy('firstName')).then(function (doc) {
      _this3.dataReady = true;
    }).catch(function (error) {
      console.log('error in loading: ', error);
    });
    // this.$bind('emergencyReports', db.collection('emergencyReports').where('emergencyActive', '==', true))
    //   .then((emergencyReports) => {
    //     console.log('Change')
    //     this.emergencyReports === emergencyReports
    //     this.reportDataReady = true
    //     if(emergencyReports.length > 0) {
    //       this.emergencyActive = true
    //     }
    //   })
    //   .catch((error) => {
    //     console.log('error in loading: ', error)
    //   })
    this.$bind('emergencyReports', __WEBPACK_IMPORTED_MODULE_3__main_js__["db"].collection('emergencyReports').where('emergencyActive', '==', true).onSnapshot(function (snapshot) {
      snapshot.docChanges().forEach(function (change) {
        console.log(change.doc.data());
        _this3.emergencyReports.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, change.doc.data(), {
          id: change.doc.id
        }));
      });
      console.log(_this3.emergencyReports);
      if (_this3.emergencyReports.length > 0) {
        _this3.emergencyActive = true;
      }
      _this3.reportDataReady = true;
    }));
    // .then((emergencyReports) => {
    //   console.log('Change')
    //   this.emergencyReports === emergencyReports
    //   this.reportDataReady = true
    //   if(emergencyReports.length > 0) {
    //     this.emergencyActive = true
    //   }
    // })
    // .catch((error) => {
    //   console.log('error in loading: ', error)
    // })
  },

  filters: {
    moment: function moment(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('h:mm:ss a');
    },
    momentDay: function momentDay(date) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format('MMMM Do YYYY');
    }
  },
  created: function created() {
    if (__WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().currentUser) {
      this.name = __WEBPACK_IMPORTED_MODULE_2_firebase___default.a.auth().currentUser.email;
    }
  }
});

/***/ }),

/***/ 200:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['person', 'seen', 'eventStartTime'],
  data: function data() {
    return {
      size: 75
    };
  },

  methods: {
    onSiteCheckIcon: function onSiteCheckIcon(status) {
      var icon = 'check';
      if (status === 'Offsite' || status === 'No Activity') {
        icon = 'highlight_off';
      }
      return icon;
    },
    determineIfAtExitPoint: function determineIfAtExitPoint(status, time) {
      if (status !== 'Offsite') {
        return status;
      }
      if (this.getSeconds(time) < this.eventStartTime.seconds) {
        return status;
      }
      return 'At muster point';
    },
    getSeconds: function getSeconds(time) {
      return Math.round(time.getTime() / 1000);
    }
  },
  filters: {
    moment: function moment(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('h:mm:ss a');
    },
    momentDay: function momentDay(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('MMMM Do YYYY');
    }
  }
});

/***/ }),

/***/ 202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(50);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5aa709b7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(256);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5aa709b7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 203:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavBar_vue__ = __webpack_require__(51);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cdc2a80_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavBar_vue__ = __webpack_require__(254);
function injectStyle (ssrContext) {
  __webpack_require__(204)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NavBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cdc2a80_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 204:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-navigation-drawer',{attrs:{"app":"","temporary":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',{attrs:{"to":"/main"}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("home")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Main")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"to":"/user"}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("people")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Users")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"to":"/log"}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("table_chart")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("User Logs")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"to":"/about"}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("info")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("About")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"to":"/cardinfo"}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("perm_contact_calendar")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Card Information")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"to":"/changelog"}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("track_changes")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Changelog")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{attrs:{"to":"/emergency"}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("warning")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Emergency")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{on:{"click":_vm.logout}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("exit_to_app")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Logout")])],1)],1)],1)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"blue",attrs:{"flat":"","dark":""}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('v-toolbar-title',[_c('img',{staticStyle:{"height":"40px","padding-top":"10px"},attrs:{"src":__webpack_require__(255)}})]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.name))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/onsight_logo.c641b45.png";

/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.$route.name !== 'Login')?_c('nav-bar'):_vm._e(),_vm._v(" "),_c('v-content',{staticClass:"blue"},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Login__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Main__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_User__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Log__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_About__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Changes__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_CardInfo__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_firebase__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_Emergency__ = __webpack_require__(285);












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Login__["a" /* default */],
    meta: {
      requiresGuest: true
    }
  }, {
    path: '/main',
    name: 'Main',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_Main__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/user',
    name: 'User',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_User__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/log',
    name: 'Log',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_Log__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_About__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/changelog',
    name: 'ChangeLog',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_Changes__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/cardinfo',
    name: 'CardInfo',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_CardInfo__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }, {
    path: '/emergency',
    name: 'Emergency',
    component: __WEBPACK_IMPORTED_MODULE_10__pages_Emergency__["a" /* default */],
    meta: {
      requiresAuth: true
    }
  }]
});
// Nav Guards
router.beforeEach(function (to, from, next) {
  // Check for requiredAuth guard
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    // Check if NOT logged in
    if (!__WEBPACK_IMPORTED_MODULE_9_firebase___default.a.auth().currentUser) {
      // Go to login page
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      });
    } else {
      // Procedd to route
      next();
    }
  } else if (to.matched.some(function (record) {
    return record.meta.requiresGuest;
  })) {
    // Check if logged in
    if (__WEBPACK_IMPORTED_MODULE_9_firebase___default.a.auth().currentUser) {
      // Go to login page
      next({
        path: '/main',
        query: {
          redirect: to.fullPath
        }
      });
    } else {
      // Procedd to route
      next();
    }
  } else {
    // Procedd to route
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(64);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7005c2de_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(261);
function injectStyle (ssrContext) {
  __webpack_require__(260)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7005c2de_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 260:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blue lighten-2",staticStyle:{"height":"100vh"}},[_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md5":""}},[_c('v-card',{staticClass:"grey lighten-4"},[_c('v-container',[_c('v-layout',{attrs:{"column":"","align-center":""}},[_c('v-flex',[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__(262),"alt":"BLE Tracker Logo"}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","my-3":""}},[_c('h1',[_vm._v("Bluetooth Site Board")])]),_vm._v(" "),_c('v-form',{on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login($event)}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Email","rules":_vm.emailRules,"outline":"","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Password","append-icon":_vm.showPassword ? 'visibility_off' : 'visibility',"rules":_vm.passwordRules,"type":_vm.showPassword ? 'text' : 'password',"outline":"","required":""},on:{"click:append":function($event){_vm.showPassword = !_vm.showPassword}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"disabled":!_vm.valid,"block":"","color":"info"},on:{"click":_vm.login}},[_vm._v("Login")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"color":"red"},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n      "+_vm._s(_vm.errorText)+"\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ble.cabba5a.jpg";

/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__ = __webpack_require__(65);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_582dc224_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__ = __webpack_require__(267);
function injectStyle (ssrContext) {
  __webpack_require__(264)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_582dc224_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Main_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 264:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 66,
	"./af.js": 66,
	"./ar": 67,
	"./ar-dz": 68,
	"./ar-dz.js": 68,
	"./ar-kw": 69,
	"./ar-kw.js": 69,
	"./ar-ly": 70,
	"./ar-ly.js": 70,
	"./ar-ma": 71,
	"./ar-ma.js": 71,
	"./ar-sa": 72,
	"./ar-sa.js": 72,
	"./ar-tn": 73,
	"./ar-tn.js": 73,
	"./ar.js": 67,
	"./az": 74,
	"./az.js": 74,
	"./be": 75,
	"./be.js": 75,
	"./bg": 76,
	"./bg.js": 76,
	"./bm": 77,
	"./bm.js": 77,
	"./bn": 78,
	"./bn.js": 78,
	"./bo": 79,
	"./bo.js": 79,
	"./br": 80,
	"./br.js": 80,
	"./bs": 81,
	"./bs.js": 81,
	"./ca": 82,
	"./ca.js": 82,
	"./cs": 83,
	"./cs.js": 83,
	"./cv": 84,
	"./cv.js": 84,
	"./cy": 85,
	"./cy.js": 85,
	"./da": 86,
	"./da.js": 86,
	"./de": 87,
	"./de-at": 88,
	"./de-at.js": 88,
	"./de-ch": 89,
	"./de-ch.js": 89,
	"./de.js": 87,
	"./dv": 90,
	"./dv.js": 90,
	"./el": 91,
	"./el.js": 91,
	"./en-au": 92,
	"./en-au.js": 92,
	"./en-ca": 93,
	"./en-ca.js": 93,
	"./en-gb": 94,
	"./en-gb.js": 94,
	"./en-ie": 95,
	"./en-ie.js": 95,
	"./en-il": 96,
	"./en-il.js": 96,
	"./en-nz": 97,
	"./en-nz.js": 97,
	"./eo": 98,
	"./eo.js": 98,
	"./es": 99,
	"./es-do": 100,
	"./es-do.js": 100,
	"./es-us": 101,
	"./es-us.js": 101,
	"./es.js": 99,
	"./et": 102,
	"./et.js": 102,
	"./eu": 103,
	"./eu.js": 103,
	"./fa": 104,
	"./fa.js": 104,
	"./fi": 105,
	"./fi.js": 105,
	"./fo": 106,
	"./fo.js": 106,
	"./fr": 107,
	"./fr-ca": 108,
	"./fr-ca.js": 108,
	"./fr-ch": 109,
	"./fr-ch.js": 109,
	"./fr.js": 107,
	"./fy": 110,
	"./fy.js": 110,
	"./gd": 111,
	"./gd.js": 111,
	"./gl": 112,
	"./gl.js": 112,
	"./gom-latn": 113,
	"./gom-latn.js": 113,
	"./gu": 114,
	"./gu.js": 114,
	"./he": 115,
	"./he.js": 115,
	"./hi": 116,
	"./hi.js": 116,
	"./hr": 117,
	"./hr.js": 117,
	"./hu": 118,
	"./hu.js": 118,
	"./hy-am": 119,
	"./hy-am.js": 119,
	"./id": 120,
	"./id.js": 120,
	"./is": 121,
	"./is.js": 121,
	"./it": 122,
	"./it.js": 122,
	"./ja": 123,
	"./ja.js": 123,
	"./jv": 124,
	"./jv.js": 124,
	"./ka": 125,
	"./ka.js": 125,
	"./kk": 126,
	"./kk.js": 126,
	"./km": 127,
	"./km.js": 127,
	"./kn": 128,
	"./kn.js": 128,
	"./ko": 129,
	"./ko.js": 129,
	"./ky": 130,
	"./ky.js": 130,
	"./lb": 131,
	"./lb.js": 131,
	"./lo": 132,
	"./lo.js": 132,
	"./lt": 133,
	"./lt.js": 133,
	"./lv": 134,
	"./lv.js": 134,
	"./me": 135,
	"./me.js": 135,
	"./mi": 136,
	"./mi.js": 136,
	"./mk": 137,
	"./mk.js": 137,
	"./ml": 138,
	"./ml.js": 138,
	"./mn": 139,
	"./mn.js": 139,
	"./mr": 140,
	"./mr.js": 140,
	"./ms": 141,
	"./ms-my": 142,
	"./ms-my.js": 142,
	"./ms.js": 141,
	"./mt": 143,
	"./mt.js": 143,
	"./my": 144,
	"./my.js": 144,
	"./nb": 145,
	"./nb.js": 145,
	"./ne": 146,
	"./ne.js": 146,
	"./nl": 147,
	"./nl-be": 148,
	"./nl-be.js": 148,
	"./nl.js": 147,
	"./nn": 149,
	"./nn.js": 149,
	"./pa-in": 150,
	"./pa-in.js": 150,
	"./pl": 151,
	"./pl.js": 151,
	"./pt": 152,
	"./pt-br": 153,
	"./pt-br.js": 153,
	"./pt.js": 152,
	"./ro": 154,
	"./ro.js": 154,
	"./ru": 155,
	"./ru.js": 155,
	"./sd": 156,
	"./sd.js": 156,
	"./se": 157,
	"./se.js": 157,
	"./si": 158,
	"./si.js": 158,
	"./sk": 159,
	"./sk.js": 159,
	"./sl": 160,
	"./sl.js": 160,
	"./sq": 161,
	"./sq.js": 161,
	"./sr": 162,
	"./sr-cyrl": 163,
	"./sr-cyrl.js": 163,
	"./sr.js": 162,
	"./ss": 164,
	"./ss.js": 164,
	"./sv": 165,
	"./sv.js": 165,
	"./sw": 166,
	"./sw.js": 166,
	"./ta": 167,
	"./ta.js": 167,
	"./te": 168,
	"./te.js": 168,
	"./tet": 169,
	"./tet.js": 169,
	"./tg": 170,
	"./tg.js": 170,
	"./th": 171,
	"./th.js": 171,
	"./tl-ph": 172,
	"./tl-ph.js": 172,
	"./tlh": 173,
	"./tlh.js": 173,
	"./tr": 174,
	"./tr.js": 174,
	"./tzl": 175,
	"./tzl.js": 175,
	"./tzm": 176,
	"./tzm-latn": 177,
	"./tzm-latn.js": 177,
	"./tzm.js": 176,
	"./ug-cn": 178,
	"./ug-cn.js": 178,
	"./uk": 179,
	"./uk.js": 179,
	"./ur": 180,
	"./ur.js": 180,
	"./uz": 181,
	"./uz-latn": 182,
	"./uz-latn.js": 182,
	"./uz.js": 181,
	"./vi": 183,
	"./vi.js": 183,
	"./x-pseudo": 184,
	"./x-pseudo.js": 184,
	"./yo": 185,
	"./yo.js": 185,
	"./zh-cn": 186,
	"./zh-cn.js": 186,
	"./zh-hk": 187,
	"./zh-hk.js": 187,
	"./zh-tw": 188,
	"./zh-tw.js": 188
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 266;

/***/ }),

/***/ 267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticStyle:{"max-width":"500px"}},[_c('v-layout',[_c('v-flex',[_c('v-card',[_c('v-card-title',[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":""}},[_c('h2',[_vm._v("Status for "+_vm._s(_vm._f("momentDay")(Date.now())))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"round":"","color":"info"},on:{"click":function($event){$event.stopPropagation();_vm.sheet = true}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("filter_list")]),_vm._v("Filter\n                  ")],1)],1)],1),_vm._v(" "),_c('v-flex',[_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.dataHeaders,"items":_vm.dataTable,"search":_vm.search,"pagination":_vm.pagination,"loading":!_vm.dataReady},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),(_vm.showTime)?_c('div',[(props.item.status === 'No activity')?_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm._f("momentDay")(props.item.time)))]):_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm._f("moment")(props.item.time)))])]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('v-chip',{class:_vm.chipColor(props.item.status)},[_vm._v(_vm._s(props.item.status))])],1)]}}])},[_c('v-progress-linear',{attrs:{"slot":"progress","color":"blue","indeterminate":""},slot:"progress"})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-bottom-sheet',{attrs:{"value":"1"},model:{value:(_vm.sheet),callback:function ($$v) {_vm.sheet=$$v},expression:"sheet"}},[_c('v-container',{staticClass:"white"},[_c('h1',[_vm._v("Filter List")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","align-center":"","justify-space-around":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("how_to_reg")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('h2',[_vm._v("Active Today")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-switch',{model:{value:(_vm.activitySwitch),callback:function ($$v) {_vm.activitySwitch=$$v},expression:"activitySwitch"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","align-center":"","justify-space-around":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("home")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('h2',[_vm._v("Onsite only")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-switch',{model:{value:(_vm.onsiteSwitch),callback:function ($$v) {_vm.onsiteSwitch=$$v},expression:"onsiteSwitch"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","align-center":"","justify-space-around":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("book")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('h2',[_vm._v("Hide Unassigned Cards")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-switch',{model:{value:(_vm.unassignedSwitch),callback:function ($$v) {_vm.unassignedSwitch=$$v},expression:"unassignedSwitch"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","align-center":"","justify-space-around":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("calendar_today")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('h2',[_vm._v("Show time of last update")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-switch',{model:{value:(_vm.showTime),callback:function ($$v) {_vm.showTime=$$v},expression:"showTime"}})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_vue__ = __webpack_require__(189);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ec17986_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__ = __webpack_require__(270);
function injectStyle (ssrContext) {
  __webpack_require__(269)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_User_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ec17986_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_User_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 269:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-dialog',{attrs:{"max-width":"500"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentUserAdmin),expression:"currentUserAdmin"}],attrs:{"slot":"activator","color":"green","dark":"","absolute":"","top":"","small":"","right":"","fab":""},slot:"activator"},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('v-card',[_c('v-card-title',{staticClass:"headline grey lighten-2",attrs:{"primary-title":""}},[_vm._v("\n        "+_vm._s(_vm.dialogText.title)+"\n      ")]),_vm._v(" "),_c('v-container',[_c('v-layout',{attrs:{"column":""}},[(_vm.currentUserAdmin)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Kontakt ID","required":""},model:{value:(_vm.user.kontaktId),callback:function ($$v) {_vm.$set(_vm.user, "kontaktId", $$v)},expression:"user.kontaktId"}})],1):_c('v-flex',{attrs:{"xs12":""}},[_vm._v("\n            Kontakt ID: "+_vm._s(_vm.user.kontaktId)+"\n          ")]),_vm._v(" "),(_vm.currentUserAdmin)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Beacon Address","required":""},model:{value:(_vm.user.beaconAddress),callback:function ($$v) {_vm.$set(_vm.user, "beaconAddress", $$v)},expression:"user.beaconAddress"}})],1):_c('v-flex',{attrs:{"xs12":""}},[_vm._v("\n            Beacon Address: "+_vm._s(_vm.user.beaconAddress)+"\n          ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"First Name","required":""},model:{value:(_vm.user.firstName),callback:function ($$v) {_vm.$set(_vm.user, "firstName", $$v)},expression:"user.firstName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Last Name","required":""},model:{value:(_vm.user.lastName),callback:function ($$v) {_vm.$set(_vm.user, "lastName", $$v)},expression:"user.lastName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-container',[_c('span',[_vm._v("Toggle this switch on to hide card from the main screen. This is useful if no one is using this card")]),_vm._v(" "),_c('v-switch',{attrs:{"label":((_vm.user.hideOnMainScreen ? 'Hidden from' : 'Visible on') + " main screen")},model:{value:(_vm.user.hideOnMainScreen),callback:function ($$v) {_vm.$set(_vm.user, "hideOnMainScreen", $$v)},expression:"user.hideOnMainScreen"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":_vm.saveUser}},[_vm._v("\n          "+_vm._s(_vm.dialogText.button)+"\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","flat":""},on:{"click":function($event){_vm.dialog = false; _vm.user = ''}}},[_vm._v("\n          Cancel\n        ")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('h3',[_vm._v("Users")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headersComputed,"items":_vm.dataTable,"search":_vm.search,"loading":!_vm.dataReady},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.kontaktId))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentUserAdmin),expression:"currentUserAdmin"}],staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.beaconAddress))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('v-btn',{staticClass:"orange",attrs:{"icon":"","flat":""},on:{"click":function($event){_vm.openEditDialog(props.item.id)}}},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),(_vm.currentUserAdmin)?_c('v-btn',{staticClass:"red",attrs:{"icon":"","flat":""},on:{"click":function($event){_vm.deleteUser(props.item)}}},[_c('v-icon',[_vm._v("remove")])],1):_vm._e()],1)]}}])},[_c('v-progress-linear',{attrs:{"slot":"progress","color":"blue","indeterminate":""},slot:"progress"})],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{model:{value:(_vm.deleteUserModal),callback:function ($$v) {_vm.deleteUserModal=$$v},expression:"deleteUserModal"}},[_c('v-card',[_c('v-container',[_c('v-card-title',[_c('h2',[_vm._v("Are you sure you want to delete?")])]),_vm._v(" "),_c('v-card-text',[_c('span',[_c('h3',[_vm._v(_vm._s(_vm.user.name))])])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","dark":""},on:{"click":_vm.deleteUserFromFirebase}},[_vm._v("\n          Yes, Delete\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","dark":""},on:{"click":function($event){_vm.deleteUserModal = false; _vm.user = ''}}},[_vm._v("\n          No, Cancel\n        ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Log_vue__ = __webpack_require__(190);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f02e250_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Log_vue__ = __webpack_require__(273);
function injectStyle (ssrContext) {
  __webpack_require__(272)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Log_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f02e250_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Log_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 272:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","md10":"","offset-md1":""}},[_c('v-card',[_c('v-card-title',[_c('v-flex',[_c('v-menu',{ref:"menu",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.date,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){_vm.date=$event}},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Select date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":""},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menu = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.$refs.menu.save(_vm.date)}}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.dataTable,"search":_vm.search,"loading":!_vm.dataReady,"pagination":_vm.pagination},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm._f("moment")(props.item.time)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('v-chip',{class:_vm.chipColor(props.item.status)},[_vm._v(_vm._s(props.item.status))])],1)]}}])},[_c('v-progress-linear',{attrs:{"slot":"progress","color":"blue","indeterminate":""},slot:"progress"})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__(191);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0566d66b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__(276);
function injectStyle (ssrContext) {
  __webpack_require__(275)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0566d66b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 275:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',[_c('v-container',[_c('h1',[_vm._v("About Page")]),_vm._v(" "),_c('p',[_vm._v("This is a pilot product to track who is on/off site at any given time using the Bluetooth Identification cards")]),_vm._v(" "),_c('h2',[_vm._v("How to use")]),_vm._v(" "),_c('p',[_vm._v("The application is currently set up to detect bluetooth cards at 3 locations")]),_vm._v(" "),_c('img',{staticStyle:{"width":"100%","max-width":"500px"},attrs:{"src":__webpack_require__(277)}}),_vm._v(" "),_c('ul',[_c('li',[_c('p',[_vm._v("A reading at gate 1 will tell the software that the employee is offsite")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("A reading at gate 2 will tell the software that the employee is onsite via gate2 (Entry gate)")])]),_vm._v(" "),_c('li',[_c('p',[_vm._v("A reading at gate 3 will tell the software that the employee is onsite via gate3 (Alley)")])])]),_vm._v(" "),_c('h3',[_vm._v("Logging in")]),_vm._v(" "),_c('p',[_vm._v("There is currently no registration page to sign up, any new users will need to email "),_c('a',{attrs:{"href":"mailto:jarrod@digital-efficiency.co.nz"}},[_vm._v("Jarrod")]),_vm._v(" with the email they will use to sign in and password so they can be added")]),_vm._v(" "),_c('h3',[_vm._v("Main Page")]),_vm._v(" "),_c('p',[_vm._v("This shows employee in/out traffic for the current day only")]),_vm._v(" "),_c('h3',[_vm._v("Users")]),_vm._v(" "),_c('p',[_vm._v("This shows all employees currently registered with the application and what card they have.")]),_vm._v(" "),_c('h3',[_vm._v("User Log")]),_vm._v(" "),_c('p',[_vm._v("This is a log of all events. You can filter by employee and date")]),_vm._v(" "),_c('h2',[_vm._v("How to give feedback and report bugs")]),_vm._v(" "),_c('p',[_vm._v("To provide feedback please email Jarrod and Paul (contact details below). When emailing please provide as much information as possible.")]),_vm._v(" "),_c('h5',[_vm._v("Bugs")]),_vm._v(" "),_c('p',[_vm._v("A screenshot and details on what you were doing leading up to the bug happening will help in addressing the problem")]),_vm._v(" "),_c('h5',[_vm._v("Feature request")]),_vm._v(" "),_c('p',[_vm._v("If its simple enough for then a description or drawing of what you want to achieve, otherwise we will meet onsite to discuss")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',{attrs:{"column":""}},[_c('h2',[_vm._v("Contact us")]),_vm._v(" "),_vm._l((_vm.contacts),function(contact,index){return _c('v-flex',{key:index,staticClass:"my-2"},[_c('h3',[_vm._v(_vm._s(contact.name))]),_vm._v(" "),_c('h4',[_vm._v("m: "),_c('a',{attrs:{"href":'mailto:' + contact.email}},[_vm._v(_vm._s(contact.email))])]),_vm._v(" "),_c('h4',[_vm._v("p: "),_c('a',{attrs:{"href":'tel:' + contact.phone}},[_vm._v(_vm._s(contact.phone))])])])})],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/siteplan.d411c18.png";

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Changes_vue__ = __webpack_require__(192);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28b26ef6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Changes_vue__ = __webpack_require__(280);
function injectStyle (ssrContext) {
  __webpack_require__(279)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Changes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28b26ef6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Changes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 279:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',[_c('v-container',[_c('h1',[_vm._v("Change Log")]),_vm._v(" "),_c('p',[_vm._v("All notable changes to this project will be documented in this file. Changes include Web App, Nodes and serverside code")]),_vm._v(" "),_c('h2',[_vm._v("[Unreleased]")]),_vm._v(" "),_c('h2',[_vm._v("1.0.12 - 13/3/2019")]),_vm._v(" "),_c('h3',[_vm._v("Added")]),_vm._v(" "),_c('ul',[_c('li',[_c('strong',[_vm._v("Web App")]),_vm._v(" Ability to persist emergency data and close the event")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('h2',[_vm._v("1.0.11 - 12/3/2019")]),_vm._v(" "),_c('h3',[_vm._v("Added")]),_vm._v(" "),_c('ul',[_c('li',[_c('strong',[_vm._v("Web App")]),_vm._v(" Updated visuals and added onsight logo")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('h2',[_vm._v("1.0.10 - 11/3/2019")]),_vm._v(" "),_c('h3',[_vm._v("Added")]),_vm._v(" "),_c('ul',[_c('li',[_c('strong',[_vm._v("Web App")]),_vm._v(" Moved time updated to be optional in main screen, now toggled in filter button")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Web App")]),_vm._v(" Added blue to the status of being onsite on the main page")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Web App")]),_vm._v(" Added ability to hide users on the main screen from user editing page")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h2',[_vm._v("1.0.9 - 8/3/2019")]),_vm._v(" "),_c('h3',[_vm._v("Fixed")]),_vm._v(" "),_c('ul',[_c('li',[_c('strong',[_vm._v("Web App")]),_vm._v(" Safaris and iOs issue with the user logs screen")])]),_vm._v(" "),_c('h2',[_vm._v("1.0.9 - 21/11/2018")]),_vm._v(" "),_c('h3',[_vm._v("Added")]),_vm._v(" "),_c('ul',[_c('li',[_c('strong',[_vm._v("Web App")]),_vm._v(" Added emergency page to the site")])]),_vm._v(" "),_c('h2',[_vm._v("1.0.8 - 21/11/2018")]),_vm._v(" "),_c('h3',[_vm._v("Added")]),_vm._v(" "),_c('ul',[_c('li',[_c('strong',[_vm._v("Web App")]),_vm._v(" Added Card info to the site")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Web App")]),_vm._v(" Added ability to filter out blank cards")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h2',[_vm._v("1.0.7 - 20/11/2018")]),_vm._v(" "),_c('h3',[_vm._v("Changed")]),_vm._v(" "),_c('ul',[_c('li',[_c('strong',[_vm._v("Web App")]),_vm._v(" Added admin ability to add cards to web application")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h2',[_vm._v("1.0.6 - 19/11/2018")]),_vm._v(" "),_c('h3',[_vm._v("Changed")]),_vm._v(" "),_c('ul',[_c('li',[_c('strong',[_vm._v("Web App")]),_vm._v(" Added filter button to main screen")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('h2',[_vm._v("1.0.5 - 31/10/2018")]),_vm._v(" "),_c('h3',[_vm._v("Changed")]),_vm._v(" "),_c('ul',[_c('li',[_c('strong',[_vm._v("Web App")]),_vm._v(" Increased default pagination on main screen")])]),_vm._v(" "),_c('h2',[_vm._v("1.0.4 - 26/10/2018")]),_vm._v(" "),_c('h3',[_vm._v("Changed")]),_vm._v(" "),_c('ul',[_c('li',[_c('strong',[_vm._v("Web App")]),_vm._v(" Added the ability to select a day in the user logs")])]),_vm._v(" "),_c('h2',[_vm._v("1.0.3 - 20/10/2018")]),_vm._v(" "),_c('h3',[_vm._v("Changed")]),_vm._v(" "),_c('ul',[_c('li',[_c('strong',[_vm._v("Server")]),_vm._v(" Reduced update rate for any ID to no more than 2 seconds")])]),_vm._v(" "),_c('h2',[_vm._v("1.0.2 - 18/10/2018")]),_vm._v(" "),_c('h3',[_vm._v("Added")]),_vm._v(" "),_c('ul',[_c('li',[_c('strong',[_vm._v("Web App")]),_vm._v(" Added a changelog to track changes")])]),_vm._v(" "),_c('h3',[_vm._v("Changed")]),_vm._v(" "),_c('ul',[_c('li',[_c('strong',[_vm._v("Web App")]),_vm._v(" After typing password, hitting enter will also log you in")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Web App")]),_vm._v(" Reduced user log table to only display 25 results. Temporary fix until date filtering can be implemented")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Nodes")]),_vm._v(" Changed range from all RSSI to anything above -92")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Server")]),_vm._v(" Fixed a database read error where the server was quering the database multiple times")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Server")]),_vm._v(" Lowered the update rate to the database")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardInfo_vue__ = __webpack_require__(193);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_224d9fee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardInfo_vue__ = __webpack_require__(283);
function injectStyle (ssrContext) {
  __webpack_require__(282)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_224d9fee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 282:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',[_c('v-container',[_c('v-layout',[_c('v-flex',[_c('h1',[_vm._v("How to turn on/off Kontakt card")]),_vm._v(" "),_c('p',[_vm._v("Kontakt.io Card Beacons are equipped in small ON/OFF switch.")]),_vm._v(" "),_c('p',[_vm._v("Considering the lanyard hole is the top of Beacon, move the switch to the left to turn it ON or move the switch to the right to turn it OFF.")]),_vm._v(" "),_c('p',[_vm._v("When Card Beacon is OFF it will not broadcasting any BLE signal and cannot be read by any Bluetooth devices.")]),_vm._v(" "),_c('p',[_vm._v("Below illustration shows how to turn on/off Card Beacon.")]),_vm._v(" "),_c('img',{staticStyle:{"width":"100%","max-width":"500px"},attrs:{"src":__webpack_require__(284)}})])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/onOff.fdfd5cb.gif";

/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Emergency_vue__ = __webpack_require__(194);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed6d79fe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Emergency_vue__ = __webpack_require__(319);
function injectStyle (ssrContext) {
  __webpack_require__(286)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Emergency_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed6d79fe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Emergency_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 286:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 316:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PersonCard_vue__ = __webpack_require__(200);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2ecbc6c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PersonCard_vue__ = __webpack_require__(318);
function injectStyle (ssrContext) {
  __webpack_require__(317)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c2ecbc6c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PersonCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2ecbc6c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PersonCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 317:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"rounded-card",attrs:{"dark":"","color":_vm.seen ? 'success' : ''}},[_c('V-container',[_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-icon',{attrs:{"size":_vm.size}},[_vm._v("face")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.person.name))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.determineIfAtExitPoint(_vm.person.status, _vm.person.time)))]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.person.status === 'No activity')?_c('span',{staticClass:"body-1"},[_vm._v(_vm._s(_vm._f("momentDay")(_vm.person.time)))]):_c('span',{staticClass:"body-1"},[_vm._v(_vm._s(_vm._f("moment")(_vm.person.time)))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-icon',{attrs:{"size":_vm.size}},[_vm._v("\n          "+_vm._s(_vm.seen ? 'check' : 'highlight_off')+"\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataReady && _vm.reportDataReady)?_c('div',[(!_vm.emergencyActive)?_c('v-container',[(!_vm.emergencyTriggered)?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"block":"","color":"warning"},on:{"click":_vm.startEmergency}},[_vm._v("\n          "+_vm._s(_vm.emergencyText)+"\n        ")])],1)],1):_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-btn',{attrs:{"block":"","color":"warning"},on:{"click":_vm.startEmergency}},[_vm._v("\n          "+_vm._s(_vm.emergencyText)+"\n        ")])],1),_vm._v(" "),_c('v-flex',[_c('v-btn',{attrs:{"xs4":"","block":"","color":"success"},on:{"click":_vm.cancelEmergency}},[_vm._v("No, Cancel")])],1)],1)],1):_c('v-container',{attrs:{"grid-list-xl":"","pb-5":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-dialog',{attrs:{"width":"500"},model:{value:(_vm.closeEmergencyDialog),callback:function ($$v) {_vm.closeEmergencyDialog=$$v},expression:"closeEmergencyDialog"}},[_c('v-btn',{attrs:{"slot":"activator","round":""},on:{"click":function($event){_vm.closeEmergencyDialog = true}},slot:"activator"},[_vm._v("close emergency")]),_vm._v(" "),_c('v-card',[_c('v-container',[_c('v-card-title',{staticClass:"headline",attrs:{"primary-title":""}},[_vm._v("\n                Are you sure you want to close the emergency?\n              ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-btn',{attrs:{"color":"warning"},on:{"click":_vm.closeEmergency}},[_vm._v("Close")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.closeEmergencyDialog = false}}},[_vm._v("Cancel")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs6":""}},[_c('v-dialog',{attrs:{"width":"500"},model:{value:(_vm.filterDialog),callback:function ($$v) {_vm.filterDialog=$$v},expression:"filterDialog"}},[_c('v-btn',{attrs:{"slot":"activator","round":"","color":"red lighten-2","dark":""},slot:"activator"},[_vm._v("\n            Filter\n          ")]),_vm._v(" "),_c('v-card',[_c('v-card-title',{staticClass:"headline grey lighten-2",attrs:{"primary-title":""}},[_vm._v("\n              Filter list\n            ")]),_vm._v(" "),_c('v-container',[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',[_c('v-switch',{attrs:{"label":("Hide with no activity today: " + (_vm.filter.noActivity.toString()))},model:{value:(_vm.filter.noActivity),callback:function ($$v) {_vm.$set(_vm.filter, "noActivity", $$v)},expression:"filter.noActivity"}})],1),_vm._v(" "),_c('v-flex',[_c('v-switch',{attrs:{"label":("Hide people you have seen: " + (_vm.filter.visuallySeen.toString()))},model:{value:(_vm.filter.visuallySeen),callback:function ($$v) {_vm.$set(_vm.filter, "visuallySeen", $$v)},expression:"filter.visuallySeen"}})],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){_vm.filterDialog = false}}},[_vm._v("\n                Close\n              ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.dataTable),function(person,key){return _c('v-flex',{key:key,attrs:{"xs12":"","md6":"","lg4":""}},[(_vm.emergencyActive)?_c('person-card',{attrs:{"person":person,"eventStartTime":_vm.emergencyReports[0].startTime,"seen":_vm.emergencyReports[0].userVisuallySeenKey.length === 0 ? false : _vm.hasUserBeenChecked(person)},nativeOn:{"click":function($event){_vm.updateSeenStatus(person, key)}}}):_vm._e()],1)}))],1),_vm._v(" "),(_vm.emergencyActive)?_c('v-bottom-nav',{attrs:{"value":true,"fixed":"","color":"white"}},[_c('v-btn',{attrs:{"color":"black","flat":"","value":"recent"}},[_c('span',[_vm._v("Total Staff "+_vm._s(_vm.totalStaffActiveToday))]),_vm._v(" "),_c('v-icon',[_vm._v("people")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"black","flat":"","value":"favorites"}},[_c('span',[_vm._v("Staff onsite "+_vm._s(_vm.totalStaffStillOnsite))]),_vm._v(" "),_c('v-icon',[_vm._v("warning")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"black","flat":"","value":"nearby"}},[_c('span',[_vm._v("Staff seen "+_vm._s(_vm.totalStaffSeen))]),_vm._v(" "),_c('v-icon',[_vm._v("done")])],1)],1):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 321:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_NavBar__ = __webpack_require__(203);
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { NavBar: __WEBPACK_IMPORTED_MODULE_0__components_NavBar__["a" /* default */] },
  data: function data() {
    return {};
  },

  name: 'App'
});

/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      drawer: false,
      name: '',
      isLoggedIn: false,
      currentUser: false,
      currentUserAdmin: false
    };
  },
  created: function created() {
    if (__WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().currentUser) {
      this.name = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().currentUser.email;
    }
  },

  methods: {
    logout: function logout() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signOut().then(function () {
        _this.$router.push('/');
      });
    }
  }
});

/***/ }),

/***/ 64:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      email: '',
      password: '',
      showPassword: false,
      valid: false,
      emailRules: [function (v) {
        return !!v || 'E-mail is required';
      }, function (v) {
        return (/.+@.+/.test(v) || 'E-mail must be valid'
        );
      }],
      passwordRules: [function (v) {
        return !!v || 'Password is required';
      }],
      errorText: '',
      snackbar: false
    };
  },

  methods: {
    login: function login() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.auth().signInWithEmailAndPassword(this.email, this.password).then(function (user) {
        console.log(user);
        _this.$router.push('/main');
      });
    },
    submit: function submit() {
      if (this.email === 'j@test.com' && this.password === '123456') {
        this.$router.push('main');
        console.log('Login correct');
      } else {
        this.snackbar = true;
        this.errorText = 'Incorect details';
        this.password = '';
      }
    }
  }
});

/***/ }),

/***/ 65:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_js__ = __webpack_require__(15);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dataReady: false,
      search: "",
      users: [],
      pagination: {
        rowsPerPage: 25
      },
      headers: [{
        text: "Name",
        align: "left",
        sortable: true,
        value: "name"
      }, {
        text: "Updated",
        align: "left",
        value: "time"
      }, {
        text: "Status",
        align: "right",
        value: "status"
      }],
      sheet: false,
      // Filters
      showTime: false,
      activitySwitch: false,
      onsiteSwitch: false,
      unassignedSwitch: true
    };
  },

  methods: {
    chipColor: function chipColor(status) {
      var color = "grey";
      switch (status) {
        case "Offsite":
          color = "green";
          break;
        case "Onsite, via Gate 2":
          color = "orange";
          break;
        case "Onsite, via Gate 3":
          color = "orange";
          break;
      }
      return color;
    },
    chooseDateFilter: function chooseDateFilter(status) {
      if (status === "No activity") {
        return this.moment;
      } else {
        return this.momentDay;
      }
    },
    filterList: function filterList(person) {
      if (person.hideOnMainScreen) {
        return false;
      }
      if (this.activitySwitch) {
        if (person.status === "No activity") {
          return false;
        }
      } else if (this.onsiteSwitch) {
        if (person.status !== "Onsite, via Gate 3" && person.status !== "Onsite, via Gate 2") {
          return false;
        }
      } else if (this.unassignedSwitch) {
        if (person.name.length === 1) {
          return false;
        }
      }
      return true;
    }
  },
  computed: {
    dataHeaders: function dataHeaders() {
      if (this.showTime) {
        return [{
          text: "Name",
          align: "left",
          sortable: true,
          value: "name"
        }, {
          text: "Updated",
          align: "left",
          value: "time"
        }, {
          text: "Status",
          align: "right",
          value: "status"
        }];
      } else {
        return [{
          text: "Name",
          align: "left",
          sortable: true,
          value: "name"
        }, {
          text: "Status",
          align: "right",
          value: "status"
        }];
      }
    },
    dataTable: function dataTable() {
      var _this = this;

      var data = [];
      if (this.users !== null) {
        this.users.forEach(function (u) {
          if ("status" in u) {
            var now = new Date();
            var obj = {
              name: u.firstName + " " + u.lastName,
              time: u.updatedAt.toDate(),
              status: "No activity",
              hideOnMainScreen: false
            };
            if ('hideOnMainScreen' in u) {
              obj.hideOnMainScreen = u.hideOnMainScreen;
            }
            if (u.updatedAt.toDate().getDate() === now.getDate()) {
              obj.status = u.status;
            }
            if (_this.filterList(obj)) {
              data.push(obj);
            }
          }
        });
      }
      return data;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$bind("users", __WEBPACK_IMPORTED_MODULE_1__main_js__["db"].collection("users").orderBy("lastName")).then(function (doc) {
      _this2.dataReady = true;
    }).catch(function (error) {
      console.log("error in loading: ", error);
    });
  },

  filters: {
    moment: function moment(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format("h:mm:ss a");
    },
    momentDay: function momentDay(date) {
      return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format("MMMM Do YYYY");
    }
  }
});

/***/ })

},[15]);


// WEBPACK FOOTER //
// static/js/app.c38e4f312e895ed284d4.js